import React from 'react'
import { setShippingConfig, getShippingConfig } from '@/lib/shippingConfig'
import { useAppConfig } from '@/contexts/AppConfigContext'

type Ctx = { loaded: boolean }

const ShippingConfigContext = React.createContext<Ctx>({ loaded: false })

export const ShippingConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [ready, setReady] = React.useState(!!getShippingConfig())
  const app = useAppConfig()

  React.useEffect(() => {
    if (app.shipping) {
      setShippingConfig(app.shipping)
      setReady(true)
    } else if (getShippingConfig()) {
      setReady(true)
    }
  }, [app.shipping])

  return (
    <ShippingConfigContext.Provider value={{ loaded: ready || app.ready }}>
      {children}
    </ShippingConfigContext.Provider>
  )
}

export const useShippingConfigLoaded = () => React.useContext(ShippingConfigContext)
